import React from "react";
import InputField from "../../components/InputField";
import { useSelector } from "react-redux";
import useNewProductFormHandler from "../../components/hooks/new-product-form-handler";

const NewProductTab = ({ product }) => {
  const { categories } = useSelector((state) => state?.categories);
  const { errors, handleChange, handleSubmit, touched, values } =
    useNewProductFormHandler(product);
  return (
    <div>
      <form className="">
        <div className="space-y-4">
          <InputField
            label="Product name"
            id="name"
            type="text"
            value={values.name}
            onChange={handleChange("name")}
            errorMsg={touched.name ? errors.name : undefined}
            placeholder="macbook"
          />
          <div>
            <p className="text-sm">Description</p>
            <textarea
              className="resize-none w-full h-52 text-sm p-2 border border-gray-300 rounded-sm"
              label="Description"
              id="description"
              type="text"
              value={values.description}
              onChange={handleChange("description")}
              placeholder="500 GB HDD, 256 GB SSD radion graphics"
            />
            <div className="text-red-500">
              {touched.description ? errors.description : undefined}
            </div>
          </div>
          <div>
            <p className="text-sm">Category</p>
            <select
              className="border border-gray-300 p-2 text-gray-500 text-sm"
              label="Category"
              id="category"
              value={values.category_id}
              onChange={handleChange("category_id")}
            >
              {categories?.data?.map((item) => {
                return (
                  <option key={item?.id} value={item?.id}>
                    {item?.category.toLowerCase()}
                  </option>
                );
              })}
            </select>
            <div className="text-red-500">
              {touched.category_id ? errors.category_id : undefined}
            </div>
          </div>
        </div>
        <div className="mt-4">
          <button
            onClick={handleSubmit}
            className="block w-full py-2 text-center text-primary bg-transparent border border-primary rounded hover:border-gray-300 hover:text-primary transition uppercase font-roboto font-medium"
          >
            create product
          </button>
        </div>
      </form>
    </div>
  );
};

export default NewProductTab;
